<script setup lang="ts">
  defineProps<{
    icon: string
    label?: string
  }>()
</script>

<template>
  <div
    role="button"
    :aria-label="label"
    class="w-icon h-icon box-content cursor-pointer p-1 rounded-sm hover:bg-white-gray transition-colors items-center justify-center flex"
  >
    <des-icon :icon="icon" class="w-icon h-icon pointer-events-none" />
  </div>
</template>
